import { ConditionReport } from "@skinsoft/types";
import { SEARCH_TYPES } from "@skinsoft/const";

import { ConditionReportDataStore } from "@skinsoft/entity";
import { CACHE_KEYS, ConditionReportOfflineDataFetcher } from "@skinsoft/offline";
import { EntitySyncDownHandler } from "../../entity-sync-down-handler";
import { cleanRefs, cleanValueToSort } from "@skinsoft/utils";

declare const config
const SEARCH_PAGE_SIZE = config.syncDownPageSize.conditionReport ?? config.syncDownPageSize.default

export class ConditionReportSyncDownHandler extends EntitySyncDownHandler<ConditionReport, ConditionReport, ConditionReport> {
    private static instance: ConditionReportSyncDownHandler = null as any

    public static getInstance() {
        if (!ConditionReportSyncDownHandler.instance) {
            ConditionReportSyncDownHandler.instance = new ConditionReportSyncDownHandler()
        }

        return ConditionReportSyncDownHandler.instance
    }

    public static install(Vue) {
        ConditionReportSyncDownHandler.getInstance()
    }

    constructor() {
        super(
            [SEARCH_TYPES.conditionReport],
            ConditionReportDataStore.getInstance(),
            new ConditionReportOfflineDataFetcher(),
            CACHE_KEYS.ConditionReport,
            SEARCH_PAGE_SIZE,
        )
    }

    formatDataForCaching(rawData: ConditionReport[]): ConditionReport[] {
        return rawData.map(report => {
            let res = cleanRefs(report)
            res = cleanValueToSort(res)

            const linkableItem = {
                ref: res.conditionReportCS.linkableItem,
                linkableItem: res.conditionReportCS.linkableItem,
            }

            res.conditionReportCS.linkableItem = linkableItem

            return res
        })
    }
}